module.exports = __webpack_public_path__ + "static/media/IMG_3045-min.280ea929.jpg";